import { isArray, isObject } from "lodash";
import { LocalData } from "../../service/localStorage";
import * as actionTypes from "../actions/actionTypes";
const localData = new LocalData();

export const defTable = {
  defaultColumnStates: {"OrderType":false,"stage":true,"Status":true,"routeName":true,"createdAt":true,"zone":true,"statusUpdatedAt":true,"note":true,"DeliveryLastAttemptReason":true,"DeliveryattemptsCount":true,"PickupFailedReason":true,"referenceId":true,"PickupAddress":true,"DeliveryAddress":true,"driverName":true,"driverPhone":true,"customerName":true,"customerPhone":true,"service":true,"price":true,"codAmount":true,"estimatedDistanceInMeters":true,"estimatedDuration":true,"Payment":true,"PickupAddressDetail":true,"PickupCompleteAfter":true,"PickupcompleteBefore":true,"PickupFullName":true,"PickupPhone":true,"PickupEmail":true,"PickupPodNote":true,"PickupPodPhoto":true,"PickupPodSignature":true,"PickupZone":true,"DeliveryAddressDetail":true,"DeliveryCompleteAfter":true,"DeliverycompleteBefore":true,"DeliveryFullName":true,"DeliveryPhone":true,"DeliveryEmail":true,"DeliveryPodNote":true,"DeliveryPodPhoto":true,"DeliveryPodSignature":true,"DeliveryZone":true,"driverVehicle":true,"driverUsername":true,"customerType":true,"customerEmail":true,"paymentProvider":true,"source":true,"Receipt":true,"shipmentLabelUrl":true,"trackOrder":true}
  ,
  defaultColumnOrders:  null,
  selectedOrders: {},
  routeList: {
    open: false,
    list: [],
  },
  tableInit: null,
  list: {
    endCursor: null,
    hasNextPage: false,
    hasPreviousPage: false,
    orders: null,
    startCursor: null,
    totalCount: null
  },
  isLoading: false,
  hasError: false,
  perPage: 30,
  page: 1,

  selectedBulkEditStatusSummary: null,
  activeFilters:  [],
  filters:  {
    deliveryMethods:[],

    cursor: "createdAt",
    cursorSort: "desc",
    services: [] /* [""] */,
    paymentSides: [] /* [""] */,
    zones: [] /* [""] */,
    vehicleTypes: [] /* [""] */,
    status: [] /* [""] */,
    stages: [] /* [""] */,
    paymentMethods: [] /* [""] */,
    type: null,
    dueDate: { equal: null, gte: null, lte: null },
    createdAt: { equal: null, gte: null, lte: null },
    statusUpdatedAt: { equal: null, gte: null, lte: null },
    price: { equal: null, gte: null, lte: null },
    codAmount: { equal: null, gte: null, lte: null },
    pickup: {
      failedReasons:[],
      completeAfter: {
        equal: null,
        gte: null,
        lte: null
      },
      completeBefore: {
        equal: null,
        gte: null,
        lte: null
      },
      zones: [] /* [] */
    },
    delivery: {
      lastAttemptReasons:[],
      attemptsCount: {
        equal: null,
        gte: null,
        lte: null
      },
      completeAfter: {
        equal: null,
        gte: null,
        lte: null
      },
      completeBefore: {
        equal: null,
        gte: null,
        lte: null
      },
      zones: [] /* [] */
    },
    regex: [] /*[
      {
        field :"",
        text:""
      },
      {
        field :"",
        text:""
      }
    ]*/

  }

};


export const initTable = {
  defaultColumnStates: localData.get("ReduxLocal_TabledefaultColumnStates") ? JSON.parse(localData.get("ReduxLocal_TabledefaultColumnStates")) :  defTable?.defaultColumnStates ,
  defaultColumnOrders: localData.get("ReduxLocal_TabledefaultColumnOrders") ? JSON.parse(localData.get("ReduxLocal_TabledefaultColumnOrders")) : null,
  selectedOrders: {},
  routeList: {
    open: false,
    list: [],
  },
  tableInit: null,
  list: {
    endCursor: null,
    hasNextPage: false,
    hasPreviousPage: false,
    orders: null,
    startCursor: null,
    totalCount: null
  },
  isLoading: false,
  hasError: false,
  perPage: 30,
  page: 1,
  DeliveryMethods:[],
  selectedBulkEditStatusSummary: null,
  activeFilters:  localData.get("ReduxLocal_TableactiveFilters") ? JSON.parse(localData.get("ReduxLocal_TableactiveFilters")) :  [],
  filters: localData.get("ReduxLocal_Tablefilters") ? {...defTable.filters , ...JSON.parse(localData.get("ReduxLocal_Tablefilters"))} : {
    cursor: "createdAt",
    cursorSort: "desc",
    deliveryMethods:[],
    services: [] /* [""] */,
    zones: [] /* [""] */,
    vehicleTypes: [] /* [""] */,
    status: [] /* [""] */,
    stages: [] /* [""] */,
    paymentMethods: [] /* [""] */,
    paymentSides: [] /* [""] */,
    type: null,
    dueDate: { equal: null, gte: null, lte: null },
    createdAt: { equal: null, gte: null, lte: null },
    statusUpdatedAt: { equal: null, gte: null, lte: null },
    price: { equal: null, gte: null, lte: null },
    codAmount: { equal: null, gte: null, lte: null },
    pickup: {
      failedReasons:[],
      completeAfter: {
        equal: null,
        gte: null,
        lte: null
      },
      completeBefore: {
        equal: null,
        gte: null,
        lte: null
      },
      zones: [] /* [] */
    },
    delivery: {
      lastAttemptReasons:[],
      attemptsCount: {
        equal: null,
        gte: null,
        lte: null
      },
      completeAfter: {
        equal: null,
        gte: null,
        lte: null
      },
      completeBefore: {
        equal: null,
        gte: null,
        lte: null
      },
      zones: [] /* [] */
    },
    regex: [] /*[
      {
        field :"",
        text:""
      },
      {
        field :"",
        text:""
      }
    ]*/

  }

};
export const Table = (state = initTable, action) => {
  switch (action.type) {
    case actionTypes.Table_SelectOrder:

      const orderIsSelectedNow = state.selectedOrders[action.state?.id];

      if (orderIsSelectedNow) {
        return state;
      } else {
        return {
          ...state,
          selectedOrders: { ...state.selectedOrders, [action.state.id]: action.state }
        };
      }


    case actionTypes.Table_SelecteMultiOrders:
  


      if (isArray(action.state)) {
        let newList = {}
      action.state.forEach((od) => {
        newList[od.id] = od
      });
      return {
        ...state,
        selectedOrders: { ...state.selectedOrders,  ...newList } 
       };
      } else {
        let isObjectx = isObject(action.state)
        let dataasa = isObjectx && action.state
        return {
          ...state,
          selectedOrders: { ...state.selectedOrders, ...dataasa }
        };
      }





    case actionTypes.Table_DeSelectOrder:
      let xx = state.selectedOrders;
      delete xx[action.state]
      return {
        ...state,
        selectedOrders: { ...xx }
      };

    case 'Table_DeSelectMultiOrders':
      // یک نسخهٔ عمیق و ایمن از selectedOrders بساز
      let updatedSelected = { ...state.selectedOrders };

         // اگر آرایه باشد، برای هر آیتم یک id استخراج کن و حذف کن
        action.state.forEach((ord) => {
          const id = (typeof ord === 'object' ? ord.id : ord);
          delete updatedSelected[id];
        });
    

      return {
        ...state,
        selectedOrders: updatedSelected
      };

    case actionTypes.table_setRouteList:
      return {
        ...state,
        routeList: {
          ...state.routeList,
          [action.state.key]: action.state.value
        }
      };


      case actionTypes.setTableDeliveryMethods:
        return {
          ...state,
          DeliveryMethods : action.state
        };

    case actionTypes.Table_ClearSelectedOrders:

      return {
        ...state,
        selectedOrders: {}
      };

    case actionTypes.Table_setData:

      return {
        ...state,
        list: action.state
      };


    case actionTypes.Table_Init:

      return {
        ...state,
        tableInit: action.state
      };

    case actionTypes.Table_setStatus:

      return {
        ...state,
        [action.state.key]: action.state.value
      };
    case actionTypes.Table_setSelectedBulkEditStatusSummary:

      return {
        ...state,
        selectedBulkEditStatusSummary: action.state
      };

    case actionTypes.TableInputContainFilter_Add:

      return {
        ...state,
        filters: {
          ...state.filters,
          regex: [...state.filters.regex, action.state]
        }
      };

    case actionTypes.TableInputContainFilter_Update:

      return {
        ...state,
        filters: {
          ...state.filters,
          regex: state.filters.regex.map((item) => {
            if (item.field == action.state.field) {
              return action.state
            } else {
              return item
            }
          })
          // regex : state.filters.regex.filter((item)=>{
          //   return item.field != 
          // })
        }
      };

    case actionTypes.TableInputContainFilter_Delete:

      return {
        ...state,
        filters: {
          ...state.filters,
          regex: state.filters.regex.filter((item) => {
            return item.field != action.state
          })
        }
      };


    case actionTypes.TableCheckboxFilter_Update:

      return {
        ...state,
        filters: {
          ...state.filters,
          [action.state.key]: action.state.value
        }
      };

    case actionTypes.TableRadioButtonFilter_Update:

      return {
        ...state,
        filters: {
          ...state.filters,
          [action.state.key]: action.state.value
        }
      };

    case actionTypes.TableRangeFilter_Update:

      return {
        ...state,
        filters: {
          ...state.filters,
          [action.state.key]: action.state.value
        }
      };

      case actionTypes.TableSubRangeFilter_Update:

      return {
        ...state,
        filters: {
          ...state.filters,
          [action.state.key]: {
            ...state.filters[action.state.key],
            [action.state.sub]:action.state.value
          }
        }
      };


      case actionTypes.Add_ActiveFilter:

      return {
        ...state,
        activeFilters: [...state.activeFilters,action.state]
      };
      case actionTypes.clearAll_ActiveFilter:

      return {
        ...state,
        filters: {
          deliveryMethods:[],
          cursor: "createdAt",
          cursorSort: "desc",
          services: [] /* [""] */,
          zones: [] /* [""] */,
          vehicleTypes: [] /* [""] */,
          status: [] /* [""] */,
          stages: [] /* [""] */,
          paymentMethods: [] /* [""] */,
          paymentSides:[],
          type: null,
          dueDate: { equal: null, gte: null, lte: null },
          createdAt: { equal: null, gte: null, lte: null },
          statusUpdatedAt: { equal: null, gte: null, lte: null },
          price: { equal: null, gte: null, lte: null },
          codAmount: { equal: null, gte: null, lte: null },
          pickup: {
            failedReasons:[],
            completeAfter: {
              equal: null,
              gte: null,
              lte: null
            },
            completeBefore: {
              equal: null,
              gte: null,
              lte: null
            },
            zones: [] /* [] */
          },
          delivery: {
            lastAttemptReasons:[],
            attemptsCount: {
              equal: null,
              gte: null,
              lte: null
            },
            completeAfter: {
              equal: null,
              gte: null,
              lte: null
            },
            completeBefore: {
              equal: null,
              gte: null,
              lte: null
            },
            zones: [] /* [] */
          },
          regex: [] /*[
            {
              field :"",
              text:""
            },
            {
              field :"",
              text:""
            }
          ]*/
      
        }
      };


    case actionTypes.Table_reset:

      return { ...initTable };
    default:
      return state;
  }
};

export default Table;